export const UrlRegex =
  /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export function buildPageMeta(_meta) {
  const meta = Object.assign(
    {},
    {
      pageNumber: 0,
      pageSize: 0,
      pageCount: 0,
    },
    _meta
  );
  const { pageNumber, pageSize, pageCount } = meta;
  const maxPage = Math.ceil(pageCount / pageSize) || 0;
  return {
    maxPage,
    currentPage: pageNumber,
    perPage: pageSize,
    total: pageCount,
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/utils/index.js
 **/